import { Color } from './color';
/**
 * ✕
 */
export const Cross = (options, context) => {
    return Color(Object.assign({ colorAttribute: 'stroke', symbol: 'cross' }, options), context);
};
Cross.props = Object.assign({ defaultMarker: 'cross' }, Color.props);
//# sourceMappingURL=cross.js.map